
export enum IndeedCampaignBudgetType {
    OneTime = 1,
    Monthly = 2
}
